module.exports = __webpack_public_path__ + "img/logo.4392cd6f.png";